import React from "react";
import { Layers, Megaphone, Lock, Sparkles, Send, MessageCircle, Bot, Heart, Flame, Crown, Eye, Ghost } from "lucide-react";

const ICONS = {
  layers: Layers,
  megaphone: Megaphone,
  lock: Lock,
  sparkles: Sparkles,
  send: Send,
  message: MessageCircle,
  bot: Bot,
  heart: Heart,
  flame: Flame,
  crown: Crown,
  eye: Eye,
  ghost: Ghost,
};

export const ICON_OPTIONS = Object.keys(ICONS);

const Icon = ({ name = "send", className = "w-5 h-5" }) => {
  const C = ICONS[name] || Send;
  return <C className={className} strokeWidth={1.6} />;
};

export default Icon;
